import { Button } from "@/components/ui/button";
import { Edit3, Ellipsis } from "lucide-react";
import React from "react";
import PerformanceMetricsCards from "./performance-metrics-cards";
import StaffShiftTable from "./staff-shift-table";

const Component: React.FC = () => {
    return (
        <div className="flex flex-col w-full p-4 items-start justify-start gap-y-8">
            <div className="flex flex-row items-center justify-between w-full">
                <span className="text-xl font-medium">Staff Performance</span>
                <div className="flex flex-row items-center justify-end gap-x-2">
                    <Button variant="ghost" className="p-1 font-normal"><Edit3 className="w-4 h-4 mr-2" />Edit Roster</Button>
                    <Button variant="ghost"><Ellipsis /></Button>
                </div>
            </div>
            <PerformanceMetricsCards />
            <StaffShiftTable />
        </div>
    );
}

export default Component;